/**
 * 邮箱注册
 */
import React, { Component } from "react";
import loading from 'c-up-loading';
import notification from 'c-notification';
import EmailLogin from './index';

class EmailRegister extends Component{
	constructor(props){
		super(props);
		this.state = {
			childProps: props.childProps
		}
	}
	setInitState(state){
		// this.setState({childProps: state});
		this.refs.emailLoginWrap.setInitState(state);
	}
	render(){
		return (
			<div className="pop-no-tab">
				<EmailLogin  userProcess="register" {...this.state.childProps} ref="emailLoginWrap"/>
			</div>
		);
	}
}
module.exports = EmailRegister;


// WEBPACK FOOTER //
// ./js/component/email-login/email-register.js